import { type ApolloClient } from "@apollo/client";
import { useAnalyticsApolloClient } from "@package/ui-apollo-components";
import {
  CreateEventDocument,
  type CreateEventMutation,
  type CreateEventMutationVariables,
  EventPayloadType,
} from "@package/ui-gql/index-analytics";
import { useCallback } from "react";

type UseReloadLocationParams = (location: string) => Promise<void>;

export function useReloadLocation(
  apolloClient?: ApolloClient<object>,
): UseReloadLocationParams {
  const client = useAnalyticsApolloClient(apolloClient);

  const reload = useCallback(
    async (location: string) => {
      if (client) {
        try {
          await client.query<CreateEventMutation, CreateEventMutationVariables>(
            {
              query: CreateEventDocument,
              variables: {
                event: {
                  type: EventPayloadType.CacheReloadRequest,
                  payloadOneOf: {
                    CACHE_RELOAD_REQUEST: {
                      type: EventPayloadType.CacheReloadRequest,
                    },
                  },
                  location,
                },
              },
            },
          );
        } catch (error) {
          console.error("Error reloading location:", error);
        }
      }
    },
    [client],
  );

  return reload;
}
